<div class=" container mt-3">
  <div *ngIf="tenderData" id="invoiceSection">

    <div style="display: flex; justify-content: space-between; align-items: center; text-align: center; color: #333;">
      <div class=""> <img src="assets/images/layout/gov.jpg" height="100"
          [alt]="this.userUtilsService.selectedEnvironment?.alt" class="mr-3">
      </div>
      <div>
        <h4><strong>Government of Pakistan</strong></h4>
        <p>Public Procurement Regulatory Authority</p>
        <p>(Cabinet Division)</p>
        <h5><u><strong>INVOICE</strong></u></h5>
      </div>
      <div class=""> <img [src]="this.userUtilsService.selectedEnvironment?.src" height="100"
          [alt]="this.userUtilsService.selectedEnvironment?.alt" class="mr-3">
      </div>


    </div>

    <div style="display: flex; justify-content: space-between;  ">
      <div style="float: left;">
        <p style="margin-bottom: 0px;"><strong>{{ tenderData.CategoryName }}</strong></p>
        <p style="margin-bottom: 0px;"><strong><span *ngIf="tenderData.Isweb==0">{{tenderData?.Address}}</span><span
              *ngIf="tenderData.Isweb==1">{{tenderData?.UserAddress}}</span></strong></p>
        <p style="margin-bottom: 0px;"><span *ngIf="tenderData.Isweb==0">{{tenderData?.state_name}}</span><span
            *ngIf="tenderData.Isweb==1">{{tenderData?.UserCityNameState}}</span> </p>
        <p>Ph No. <span *ngIf="tenderData.Isweb==0">{{ tenderData.phone }}</span><span *ngIf="tenderData.Isweb==1">{{
            tenderData.UserMobile }}</span></p>
      </div>
      <div style="text-align: right;">
        <p style="margin-bottom: 0px"><strong>Invoice No: {{ tenderData.tse }}</strong></p>
        <p><strong>Date:</strong> {{ currentDate | date }}</p>
      </div>
    </div>
    <table border="1" cellspacing="0" cellpadding="8"
      style="border-collapse: collapse; width: 100%; font-family: Arial, sans-serif; text-align: left;">
      <thead style="background-color: #f2f2f2;">
        <tr>
          <td class="style9"><strong>Reference Number/ Tender No. of procuring Agencies</strong></td>
          <td class="style9"><strong>PPRA Web Reference No</strong></td>
          <td class="style9"><strong>Procurement Sector</strong></td>
          <td class="style9">
            <strong>Date of Uploading</strong>
          </td>
          <td class="style9"><strong>Total Amount<br>(PKR)
            </strong> </td>
        </tr>
      </thead>
      <tbody>
        <tr>



          <td class="style9" style="width: 332px">{{tenderData.TNo}}</td>
          <td class="style9" style="width: 138px">{{ tenderData.tse }}</td>
          <td class="style9" style="width: 88px">{{tenderData.sector_name}}</td>
          <td class="style9">


            {{tenderData?.start_date | date}}
          </td>



          <td class="style9">15,000</td>



        </tr>


      </tbody>
    </table>

    <div
      style="border-top: 2px solid #000; padding-top: 10px; font-family: Arial, sans-serif; font-size: 14px; color: #333;">
      <h3>Notes:</h3>
      <p class="mb-0">1. Payment may be made through crossed cheque, HBL Bankers cheque, pay order, online transfer, or
        demand draft in favor of <strong>PUBLIC PROCUREMENT REGULATORY AUTHORITY (PPRA)</strong>, Islamabad.</p>
      <p>2. Please ensure to mention the <strong>PPRA Invoice/Web reference number</strong> or enclose a copy of this
        invoice while remitting payment for accurate adjustment of the tender fee(s) against relevant tender notice(s).
        Otherwise, the tender fee(s) will remain outstanding against your organization.</p>

      <h4>Postal Address:</h4>
      <p class="mb-0"><strong>Deputy Director (Accounts), PPRA</strong></p>
      <p class="mt-0 mb-0">1st Floor, FBC Building, Sector G-5/2, Near State Bank of Pakistan, Islamabad.</p>
      <p class="mt-0">Phone: 0092 51 9203541 | Fax: 051 9219149, 9224823 | Email: <a
          href="mailto:faraz@ppra.org.pk">faraz@ppra.org.pk</a></p>

      <h3>Bank Details:</h3>
      <p class="mb-0"><strong>Bank A/C No.:</strong> 000-45400-131007-01, HBL, 'A' Block Branch, Pak Sectt, Islamabad
      </p>
      <p class="mt-0"><strong>IBAN No.:</strong> PK17HABB00013100701</p>

      <h3>Free Tax Number (FTN)</h3>
      <p class="mb-0"><strong>FTN No.:</strong> 9010117-7</p>
      <p class="mt-0"></p>

      <h3>AGPR (Islamabad & Regional Offices Vendors)</h3>

      <table border="1" cellspacing="0" cellpadding="8"
        style="border-collapse: collapse; width: 100%; font-family: Arial, sans-serif; text-align: left;">
        <thead>
          <tr>
            <td><strong>PPRA's AGPR Islamabad Vendor (No. 30379395)</strong></td>
            <td><strong>PPRA's AG-KPK Vendor(No. 80178117)</strong></td>
            <td><strong>PPRA's AG-Karachi Sindh Vendor(No.50305254)</strong></td>
            <td><strong>PPRA's AG-Gilgit Baltistan Vendors (No.70001748)</strong></td>

          </tr>
          <tr>
            <td></td>
            <td><strong>PPRA's AG-Lahore Vendors (No.30225360)</strong></td>
            <td><strong>PPRA's AG-Faislabad Vendors (No.30334836) </strong></td>
            <td></td>

          </tr>
        </thead>
      </table>


      <hr style="margin-top: 20px; border: 1px solid #000;">
      <p style="text-align: center; font-weight: bold;">This is a computer-generated invoice which requires no
        signature.</p>
      <div style="display: flex; justify-content: space-between; align-items: center; text-align: center; color: #333;">
        <p id="printTime" style="font-size: 12px; color: #555;"></p>
        <p id="printUrl" style="font-size: 12px; color: #555;"></p>
      </div>
    </div>



  </div>
  <div
    style="display: flex; justify-content: space-between; align-items: center; text-align: center; color: #333; margin-bottom: 10px">


    <button class="btn btn-secondary mt-3" routerLink="/activetenders">Back to Active Tenders</button>
    <button class="btn btn-primary mt-3" (click)="printInvoice()">Print Invoice</button>
  </div>
</div>